import { CalendarMonth, Call, Chat, CheckCircleOutlined, Email, HomeWork, Person, PictureAsPdf } from '@mui/icons-material';
import { ReactComponent as CopySvg } from 'assets/svg/SharableLinkCopyAction.svg';
import ModalLayout from 'components/Modals/ModalLayout';
import { useModals } from 'pages/MainProvider';
import { Lead } from 'types/Lead';
import { formatDate } from 'util/formatDate';

const formatStatus = (status: string) => {
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
};
interface Props {
    visible: boolean;
    onClose: () => void;
    lead: Lead;
}

const InfoRow = ({ icon: Icon, label, children }: { icon: React.ElementType; label: string; children: React.ReactNode }) => (
    <div className="flex sm:items-start  md:items-center sm:flex-col md:flex-row justify-start sm:gap-4 md:gap-0">
        <div className="w-56 text-gray-600">
            <span className="flex items-center gap-2">
                <Icon /> {label}
            </span>
        </div>
        <div>{children}</div>
    </div>
);

const LeadModal = ({ lead, onClose, visible }: Props) => {
    const { showPropertyDetailModal } = useModals();

    return (
        <ModalLayout visible={visible} onClose={onClose}>
            <div className="rounded-lg xl:w-[900px] h-[520px] sm:h-fit  w-full bg-gradient-to-r from-[#F5F5F5]/100 to-blue-50">
                <div className="px-6 pt-4 pb-2 bg-white">
                    <h2 className="text-2xl font-semibold mb-6 text-my-black">Leads detail</h2>
                </div>
                <div className="p-6">
                    <div className="space-y-7">
                        <InfoRow icon={CalendarMonth} label="Date">
                            <span className="font-medium text-xl">{formatDate(lead.createdAt)}</span>
                        </InfoRow>
                        <InfoRow icon={Person} label="Name">
                            <span className="font-medium text-xl">{lead?.name}</span>
                        </InfoRow>
                        <InfoRow icon={Email} label="Email">
                            <div className="flex items-center gap-2 font-medium text-xl">
                                {lead?.email}
                                <button className="p-1 hover:bg-gray-100 rounded">
                                    <CopySvg />
                                </button>
                            </div>
                        </InfoRow>
                        <InfoRow icon={Call} label="Phone number">
                            <div className="flex items-center gap-2 font-medium text-xl">
                                {lead?.phone}
                                <button className="p-1 hover:bg-gray-100 rounded">
                                    <CopySvg />
                                </button>
                            </div>
                        </InfoRow>
                        <InfoRow icon={HomeWork} label="Listing selected">
                            <div className="md:flex md:items-center  font-medium text-xl w-full ">
                                {lead?.property?.title}
                                <button className="text-blue-600 sm:ml-4 md:ml-2 " onClick={() => showPropertyDetailModal(lead.property, false)}>
                                    (View)
                                </button>
                            </div>
                        </InfoRow>
                        <InfoRow icon={CheckCircleOutlined} label="Status">
                            <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-full  text-sm">{formatStatus(lead.status)}</span>
                        </InfoRow>
                        <InfoRow icon={Chat} label="Message">
                            <div className="flex-1 text-lg">{lead?.message}</div>
                        </InfoRow>
                    </div>

                    <div className="mt-12 hidden md:block">
                        <button className="flex items-center gap-2 text-red-600 border border-red-600 px-4 py-2 rounded-lg hover:bg-red-50">
                            <PictureAsPdf /> Export Pdf
                        </button>
                    </div>
                </div>
            </div>
        </ModalLayout>
    );
};

export default LeadModal;
